import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordArrorLoopIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 10">
      <g clipPath="url(#clip0_27747_4259)">
        <path
          stroke={stroke || bordColorTheme.navyBlue[400]}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M8.926 5.98228C8.63521 6.80633 8.107 7.52589 7.40785 8.05018C6.7088 8.57453 5.87013 8.88018 4.99761 8.92861C4.19105 8.92875 3.404 8.68061 2.74335 8.21789C2.0827 7.75525 1.58048 7.10041 1.3049 6.34238M1.0692 4.01809C1.61918 2.5122 3.30839 1.07178 4.99761 1.07178C5.8081 1.07406 6.59805 1.32697 7.25914 1.79583C7.92028 2.26471 8.42014 2.92658 8.69035 3.69073M9.38428 7.42561C9.25885 6.83256 9.15864 6.51676 8.92693 5.98506C8.35893 6.10249 8.04314 6.20278 7.48635 6.44242M0.725098 2.55221C0.806305 3.15294 0.882883 3.47529 1.0746 4.02268C1.64972 3.94761 1.97205 3.87096 2.54508 3.67317"
        />
      </g>
      <defs>
        <clipPath id="clip0_27747_4259">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BordArrorLoopIcon;
